import { FaRegFolder } from 'react-icons/fa6';

interface FolderHeaderProps {
  title: string;
  documentCount: number;
  onClick: () => void;
}

/**
 * FolderHeader component that displays the folder icon, title, and document count
 *
 * @param props - Component props for folder header
 * @returns Rendered folder header with full accessibility support
 */
export const FolderHeader = ({ title, documentCount, onClick }: FolderHeaderProps) => (
  <span
    className="flex flex-1 items-center text-day-neutral-subtle"
    onClick={(event) => {
      event.stopPropagation();
      onClick();
    }}
    role="button"
    tabIndex={0}
    aria-label={`Open folder: ${title}`}
    aria-describedby={`folder-${title}-description`}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    }}
  >
    <div className="m-3 w-[14px] h-[14px] flex items-center justify-center">
      <FaRegFolder />
    </div>
    <span className="my-3 flex-1 text-sm text-day-neutral-subtle">
      {title} ({documentCount})
    </span>
    <span id={`folder-${title}-description`} className="sr-only">
      Folder containing {documentCount} documents
    </span>
  </span>
);
